var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 161,
    viewBox: "0 0 154 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_103_11337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0615234 84.4268C0.0615234 42.0213 34.4349 7.83765 76.6506 7.83765C118.803 7.83765 153.224 42.0055 153.224 84.4268C153.224 102.42 147.026 118.974 136.622 132.034C122.282 150.138 100.367 161 76.6506 161C52.7758 161 30.9881 150.059 16.6632 132.034C6.25949 118.974 0.0615234 102.42 0.0615234 84.4268Z",
    fill: "#CFF5E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8189 0.632498L96.8083 0.630954C96.2034 0.549581 95.5931 0.5 94.9787 0.5H29.338C22.7112 0.5 17.3394 5.84455 17.3394 12.4473V142.715C17.3394 149.318 22.7112 154.662 29.338 154.662H123.948C130.591 154.662 135.946 149.317 135.946 142.715V38.9309C135.946 38.0244 135.847 37.1334 135.648 36.2586C135.117 33.9311 133.874 31.7686 132.066 30.1333C132.066 30.1331 132.065 30.1329 132.065 30.1327L103.068 3.65203C103.068 3.6519 103.067 3.65177 103.067 3.65164C101.311 2.03526 99.1396 0.995552 96.8189 0.632498Z",
    fill: "white",
    stroke: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0101 21.5127H39.7196C38.9643 21.5127 38.3521 22.125 38.3521 22.8802C38.3521 23.6355 38.9643 24.2477 39.7196 24.2477H78.0101C78.7654 24.2477 79.3777 23.6355 79.3777 22.8802C79.3777 22.125 78.7654 21.5127 78.0101 21.5127Z",
    fill: "#46973B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.767 42H40.2333C38.9999 42 38 42.6716 38 43.5C38 44.3284 38.9999 45 40.2333 45H102.767C104 45 105 44.3284 105 43.5C105 42.6716 104 42 102.767 42Z",
    fill: "#46973B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.767 62H40.2333C38.9999 62 38 62.6716 38 63.5C38 64.3284 38.9999 65 40.2333 65H102.767C104 65 105 64.3284 105 63.5C105 62.6716 104 62 102.767 62Z",
    fill: "#46973B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1667 70H39.8333C38.8208 70 38 70.6716 38 71.5C38 72.3284 38.8208 73 39.8333 73H91.1667C92.1792 73 93 72.3284 93 71.5C93 70.6716 92.1792 70 91.1667 70Z",
    fill: "#46973B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3179 133.65H41.0871C39.5766 133.65 38.3521 134.874 38.3521 136.385V136.385C38.3521 137.895 39.5766 139.12 41.0871 139.12H90.3179C91.8284 139.12 93.053 137.895 93.053 136.385C93.053 134.874 91.8284 133.65 90.3179 133.65Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6597 29.718H39.7196C38.9643 29.718 38.3521 30.3303 38.3521 31.0855C38.3521 31.8408 38.9643 32.4531 39.7196 32.4531H50.6597C51.415 32.4531 52.0273 31.8408 52.0273 31.0855C52.0273 30.3303 51.415 29.718 50.6597 29.718Z",
    fill: "#46973B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3077 50.2053H39.3675C38.6123 50.2053 38 50.8176 38 51.5728C38 52.3281 38.6123 52.9404 39.3675 52.9404H50.3077C51.0629 52.9404 51.6752 52.3281 51.6752 51.5728C51.6752 50.8176 51.0629 50.2053 50.3077 50.2053Z",
    fill: "#46973B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1302 32.4528C56.8855 32.4528 57.4977 31.8406 57.4977 31.0853C57.4977 30.33 56.8855 29.7178 56.1302 29.7178C55.375 29.7178 54.7627 30.33 54.7627 31.0853C54.7627 31.8406 55.375 32.4528 56.1302 32.4528Z",
    fill: "#46973B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7782 52.9401C56.5334 52.9401 57.1457 52.3279 57.1457 51.5726C57.1457 50.8173 56.5334 50.2051 55.7782 50.2051C55.0229 50.2051 54.4106 50.8173 54.4106 51.5726C54.4106 52.3279 55.0229 52.9401 55.7782 52.9401Z",
    fill: "#46973B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5999 32.4528C62.3552 32.4528 62.9675 31.8406 62.9675 31.0853C62.9675 30.33 62.3552 29.7178 61.5999 29.7178C60.8447 29.7178 60.2324 30.33 60.2324 31.0853C60.2324 31.8406 60.8447 32.4528 61.5999 32.4528Z",
    fill: "#46973B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0702 32.4528C67.8254 32.4528 68.4377 31.8406 68.4377 31.0853C68.4377 30.33 67.8254 29.7178 67.0702 29.7178C66.3149 29.7178 65.7026 30.33 65.7026 31.0853C65.7026 31.8406 66.3149 32.4528 67.0702 32.4528Z",
    fill: "#46973B"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_103_11337)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 123.5,
    cy: 102.283,
    r: 22.2167,
    fill: "white",
    stroke: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.917 102.283C103.917 91.4674 112.684 82.7 123.5 82.7C134.316 82.7 143.083 91.4674 143.083 102.283C143.083 113.099 134.316 121.867 123.5 121.867C112.684 121.867 103.917 113.099 103.917 102.283ZM123.5 86.6166C119.345 86.6166 115.36 88.2672 112.422 91.2053C109.484 94.1433 107.833 98.1282 107.833 102.283C107.833 106.438 109.484 110.423 112.422 113.361C115.36 116.299 119.345 117.95 123.5 117.95C127.655 117.95 131.64 116.299 134.578 113.361C137.516 110.423 139.167 106.438 139.167 102.283C139.167 98.1282 137.516 94.1433 134.578 91.2053C131.64 88.2672 127.655 86.6166 123.5 86.6166Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.458 92.4915C125.458 91.9722 125.252 91.474 124.885 91.1068C124.517 90.7395 124.019 90.5332 123.5 90.5332C122.981 90.5332 122.483 90.7395 122.115 91.1068C121.748 91.474 121.542 91.9722 121.542 92.4915V100.325H113.708C113.189 100.325 112.691 100.531 112.324 100.898C111.956 101.266 111.75 101.764 111.75 102.283C111.75 102.803 111.956 103.301 112.324 103.668C112.691 104.035 113.189 104.242 113.708 104.242H121.542V112.075C121.542 112.594 121.748 113.092 122.115 113.46C122.483 113.827 122.981 114.033 123.5 114.033C124.019 114.033 124.517 113.827 124.885 113.46C125.252 113.092 125.458 112.594 125.458 112.075V104.242H133.292C133.811 104.242 134.309 104.035 134.676 103.668C135.044 103.301 135.25 102.803 135.25 102.283C135.25 101.764 135.044 101.266 134.676 100.898C134.309 100.531 133.811 100.325 133.292 100.325H125.458V92.4915Z",
    fill: "#0ACF83"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_103_11337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 154,
    height: 161,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_103_11337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    fill: "white",
    transform: "translate(100 78)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyFiles);
export default __webpack_public_path__ + "static/media/Empty_files.cf46d31dd22f1cd2b995e34e6dcbc9a9.svg";
export { ForwardRef as ReactComponent };